module.exports = __webpack_public_path__ + "static/media/1.675e9848.jpg";